import { checkValidData, middleNameFormatter } from "components/Formatter";
import {
  AudioElement,
  CommonButton,
  ImageElement,
  RippleEffect,
  VideoElement,
} from "components/UiElement";
import { ext } from "helpers";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";

function TestimonialComponent({ comment, onHandleStatus }) {
  return (
    <div className="testimonials_col">
      <Card>
        <Card.Header>
          <div className="profile d-flex align-items-center">
            {comment?.user?.profileImageUrl?.substring(
              comment?.user?.profileImageUrl?.lastIndexOf("/") + 1
            ) === "userDefault.png" ? (
              <div className="userDefault">
                <ImageElement
                  className="img-fluid"
                  previewSource={comment?.user?.profileImageUrl}
                />
              </div>
            ) : (
              <ImageElement
                className="img-fluid"
                previewSource={comment?.user?.profileImageUrl}
              />
            )}
            <div className="profile_text">
              <h3>
                {middleNameFormatter(
                  comment?.user?.firstName,
                  comment?.user?.middleName,
                  comment?.user?.lastName
                )}
              </h3>
              {/* <p className="mb-0">
                <em className="icon-location me-1" />
                {checkValidData(comment?.location)}
              </p> */}
            </div>
          </div>
        </Card.Header>
        <Card.Body>
          <Card.Text>{checkValidData(comment?.comment)}</Card.Text>
        </Card.Body>
        <Card.Footer>
          {comment?.filePathUrl && (
            <>
              {ext?.[comment?.filePathUrl?.split(".")?.pop()] === "file" &&
                // comment?.filePathUrl?.split(".")?.pop() === "PDF" ||
                // comment?.filePathUrl?.split(".")?.pop() === "docx" ?
                (
                  <>
                    <Link
                      to={comment?.filePathUrl || "#"}
                      target="blank"
                      className="w-100 pdf"
                    >
                      <ImageElement className="img-fluid" source="pdf.png" />
                      {comment?.filePathUrl
                        ? comment.filePathUrl.substring(comment.filePathUrl.lastIndexOf("/") + 1).length > 15
                          ? `${comment.filePathUrl.substring(
                            comment.filePathUrl.lastIndexOf("/") + 1,
                            comment.filePathUrl.lastIndexOf("/") + 16
                          )}...`
                          : comment.filePathUrl.substring(comment.filePathUrl.lastIndexOf("/") + 1)
                        : ""}
                    </Link>
                  </>
                )
              }

              {ext?.[comment?.filePathUrl?.split(".")?.pop()] === "image" && (
                <ImageElement
                  className="img-fluid w-100"
                  previewSource={comment?.filePathUrl}
                />
              )}

              {ext?.[comment?.filePathUrl?.split(".")?.pop()] === "audio" && (
                <AudioElement
                  classname="d-block m-auto"
                  previewSource={comment?.filePathUrl}
                  alt="timeline-img"
                />
              )}
              {ext?.[comment?.filePathUrl?.split(".")?.pop()] === "video" && (
                <>
                  {/* <Link to="#" className="landmakrPlay">
                                      <em className="icon-video" />
                                    </Link> */}
                  <VideoElement
                    previewSource={comment?.filePathUrl}
                    extraClassName="w-100 h-100 object-fit-cover"
                    alt="timeline-img"
                    controls
                    autoPlay={false}
                  />
                </>
              )}
            </>
          )}
          {onHandleStatus && (
            <div className="d-flex justify-content-between align-items-center mt-sm-3 mt-2 pt-xl-1 pt-0 w-100">
              <RippleEffect extraClassName="me-xl-3 me-2 pe-xl-1 pe-0 w-50">
                <CommonButton
                  onClick={() => {
                    onHandleStatus({ ...comment, key: "reject" });
                  }}
                  extraClassName={`btn btn-lg w-100 ${comment?.status === "reject"
                    ? "disabled bg-secondary text-white"
                    : "btn-outline-danger"
                    }`}
                >
                  {comment?.status === "reject" ? "Rejected" : "Reject"}
                </CommonButton>
              </RippleEffect>

              <RippleEffect extraClassName="w-50">
                <CommonButton
                  variant="danger"
                  extraClassName={`btn btn-lg w-100 ${comment?.status === "accept"
                    ? "bg-danger text-white"
                    : "btn-primary"
                    }`}
                  onClick={() => {
                    if (comment?.status !== "accept") {
                      onHandleStatus({ ...comment, key: "accept" });
                    }
                  }}
                >
                  {comment?.status === "accept" ? "Accepted" : "Accept"}
                </CommonButton>
              </RippleEffect>
            </div>
          )}
        </Card.Footer>
      </Card>
    </div>
  );
}

export default TestimonialComponent;
